export enum ERfqTabs {
  PRODUCT_INFO = 'Product Information',
  KIT_ITEMS = 'Kit Items',
  ATTACHMENTS = 'Attachments',
  SHIPPING_PACKING = 'Shipping and Packing Details',
  OTHERS = 'Others',
  CUSTOM_FIELDS = 'Custom Fields',
}
